export var TelemetryType = {
  LOG: 'log',
  CONFIGURATION: 'configuration',
  USAGE: 'usage'
};